var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMeta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_48688_14024)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.996 12.7045C23.996 18.7653 19.5047 23.7758 13.6702 24.5889C13.1247 24.6646 12.5665 24.7041 11.9999 24.7041C11.346 24.7041 10.7038 24.652 10.0784 24.5511C4.36656 23.6312 0.00390625 18.677 0.00390625 12.7045C0.00390625 6.07705 5.37527 0.704102 12.0008 0.704102C18.6263 0.704102 23.9977 6.07705 23.9977 12.7045H23.996Z",
    fill: "#1C1C1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.86845 5.99609L10.4012 13.3955L4.83398 19.4116H6.08731L10.9619 14.1446L14.9 19.4116H19.1643L13.3206 11.5961L18.5028 5.99609H17.2495L12.7607 10.8469L9.1336 5.99609H4.86928H4.86845ZM6.71102 6.91933H8.66959L17.3201 18.4884H15.3615L6.71102 6.91933Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_48688_14024"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.704102)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeta);
export default __webpack_public_path__ + "static/media/meta.77618748f9c3a7922b60661a5cc5171a.svg";
export { ForwardRef as ReactComponent };